export enum MainPage {
  Faq = 'faq',
  Index = 'index',
  Stake = 'stake',
  Wallet = 'wallet',
  Ecosystem = 'ecosystem',
  Governance = 'governance',
  Maintenance = 'maintenance',
  MyStaking = 'stake-my-staking',
  TokenFactory = 'token-factory',
  WalletCW20 = 'wallet-cw20-tokens',
  Validator = 'validators-validator',
  ProposalDetails = 'proposal-proposal',
  CommunityBuyback = 'community-buyback',
  WalletTransactions = 'wallet-transactions',
  ProposalCreateType = 'proposal-create-type',
  CommunityBuybackDetails = 'community-buyback-auction'
}
